import { css } from '@emotion/core'
import { smallOnly, mediumOnly, largeUp } from 'Utils'
import embedVariantSkin from './embedVariant'

export const plain = ({ theme: { typography } }) => css`
  position: fixed;
  overflow-y: scroll;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;

  .product-modal {
    &__wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1000;
      width: 800px;

      @media ${smallOnly} {
        top: 0%;
        width: 80%;
        transform: translate(-50%, 0);
        margin: 10% auto;
      }
      @media ${mediumOnly} {
        top: 0%;
        width: 60%;
        transform: translate(-50%, 0);
        margin: 10% auto;
      }
    }

    &__header {
      background-color: black;
      position: relative;
      display: flex;
      color: white;
      height: auto;
      &__title {
        text-align: center;
        font-size: ${typography.sizes.large};
        margin: 15px 7%;
        @media ${largeUp} {
          font-size: ${typography.sizes.small};
          margin: 15px auto;
        }
      }
    }

    &__content {
      background-color: white;
      min-height: 380px;
      padding: 10px;
      .product {
        border: 1px solid #979797;
      }
      @media ${smallOnly} {
        min-height: 1500px;
      }
      @media ${mediumOnly} {
        min-height: 710px;
      }
    }
  }

  .close-icon {
    fill: white;
    position: absolute;
    right: 10px;
    top: 15px;
    transform: none;
    @media ${largeUp} {
      top: 50%;
      transform: translate(0, -50%);
    }
  }
`

export default props => {
  if (props.variant === 'embedModal') {
    return embedVariantSkin()
  } else {
    return plain
  }
}
